import React from 'react';
import styled from 'styled-components';
import Colors from '@components/shared/Colors';
import { INSTAGRAM_LINK } from '@constants';
import FacebookIcon from '@images/socials-facebook.svg';
import InstagramIcon from '@images/socials-instagram.svg';
import PinterestIcon from '@images/socials-pinterest.svg';
import TiktokIcon from '@images/socials-tiktok.svg';
import TwitterIcon from '@images/socials-twitter.svg';
import YouTubeIcon from '@images/socials-youtube.svg';
import LinkTranslated from './LinkTranslated';

interface Props {
  size?: number;
  color?: string;
}

const SocialIcons: React.FC<Props> = ({ size = 21, color = Colors.cream }) => (
  <Container id="social-media" $size={size} $color={color}>
    <LinkTranslated to={INSTAGRAM_LINK} targetBlank aria-label="Visit Daye on Instagram">
      <InstagramIcon />
    </LinkTranslated>
    <LinkTranslated to="https://twitter.com/meetdaye/" targetBlank aria-label="Visit Daye on Twitter">
      <TwitterIcon />
    </LinkTranslated>
    <LinkTranslated to="https://www.facebook.com/meetdaye/" targetBlank aria-label="Visit Daye on Facebook">
      <FacebookIcon />
    </LinkTranslated>
    <LinkTranslated to="https://www.pinterest.co.uk/meetdaye/_created/" targetBlank aria-label="Visit Daye on Pinterest">
      <PinterestIcon />
    </LinkTranslated>
    <LinkTranslated to="https://www.tiktok.com/@yourdaye" targetBlank aria-label="Visit Daye on TikTok">
      <TiktokIcon />
    </LinkTranslated>
    <LinkTranslated to="https://www.youtube.com/channel/UCT3bn6wjOwulZVCQAv3mGTw" targetBlank aria-label="Visit Daye on YouTube">
      <YouTubeIcon />
    </LinkTranslated>
  </Container>
);

export default SocialIcons;

const Container = styled.section<{ $size?: number; $color?: string }>`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  column-gap: 30px;

  @media only screen and (max-width: 768px) {
    justify-content: space-between;
    column-gap: 0;
    width: 100%;
  }

  a {
    display: flex;
    align-items: center;
    transition: all 0.2s ease;

    &:hover {
      opacity: 0.7;
    }
  }

  svg {
    width: ${(props) => props.$size && `${props.$size}px`};
    height: ${(props) => props.$size && `${props.$size}px`};

    path {
      fill: ${(props) => props.$color && `${props.$color}`};
    }
  }
`;
